import { Component, inject } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

import { GlobalLoaderService } from '@core/services/global-loader.service';

@Component({
  selector: 'kl-global-loader',
  standalone: true,
  imports: [TranslateModule],
  templateUrl: './kl-global-loader.html',
  styleUrl: './kl-global-loader.scss',
})
export class KlGlobalLoaderComponent {
  private readonly globalLoader = inject(GlobalLoaderService);

  readonly visible = this.globalLoader.visible;
}
